import { getDownloadURL, ref, uploadBytes, deleteObject } from "firebase/storage";
import { storage } from "config/firebaseWithFirestore";

export async function uploadAsync({ path, file }) {
    const rf = ref(storage, path);
    return uploadBytes(rf, file);
}

export async function deleteAsync({ path }) {
    const rf = ref(storage, path);
    return deleteObject(rf);
}

export async function downloadAsync({ dirName, fileName }) {
    return new Promise(async (resolve, reject) => {
        try {
            const rf = ref(storage, `${dirName}/${fileName}`);
            const url = await getDownloadURL(rf);
            let blob = null;
            const xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = function (event) {
                blob = xhr.response;
                if (blob) {
                    blob.lastModifiedDate = new Date();
                    blob.name = fileName;
                    return resolve(blob);
                } else {
                    return resolve(null);
                }
            };
            xhr.open("GET", url);
            xhr.send();
        } catch ({ message }) {
            reject(message);
        }
    });
}

export async function getDownloadURLAsync({ dirName, fileName }) {
    const rf = ref(storage, `${dirName}/${fileName}`);
    return getDownloadURL(rf);
}
